<div *ngIf="dataSource" class="tabla-content"
  [ngStyle]="{ 'gap' : flowTable == OptionFlowTable.Mantenedor ? '2rem' : '1.5rem' }">
  
  <ng-container *ngIf="flowTable !== OptionFlowTable.Buscador; else searchTable">
    <efx-data-table class="w-100" [dataSource]="dataSource" [pageSize]="5" [ngSwitch]="flowTable">

      <efx-grid-column *ngSwitchCase="OptionFlowTable.Configuracion" field="order" header="Orden" width="8"
        [isVisible]="true" [isSortable]="true">
        <ng-template let-row="row">
          <div>
            <input [disabled]="!row.visible" class="efx-input" type="number" id="orden" min="0"
              [(ngModel)]="row.order" (ngModelChange)="emitUpdate()" />
          </div>
        </ng-template>
      </efx-grid-column>

      <efx-grid-column *ngFor="let column of columnsTable" [field]="column.field" [width]="column.width ? column.width.toString() : ''"
        [header]="column.header" [isVisible]="true" [isSortable]="column.isSortable || false">

        <ng-template let-row="row">
          <ng-container *ngIf="flowTable === OptionFlowTable.Configuracion && column.field === 'varLabel'; else defaultText">
            
            <input 
              class="efx-input w-100" 
              type="text" 
              
              [ngModel]="row.varLabel" 
              (ngModelChange)="onLabelChange(row, $event)"
              
              [disabled]="!row.visible" 
              (click)="$event.stopPropagation()"
              placeholder="Ingrese título"
            />

          </ng-container>

          <ng-template #defaultText>
            <ng-container *ngIf="flowTable === OptionFlowTable.Configuracion && column.field === 'varName'; else plainValue">
              <div class="path-cell" [attr.title]="row.varName">
                <div class="path-header">
                  <span class="path-leaf">{{ getPathLeaf(row.varName) | underscoreWrap }}</span>
                  <span *ngIf="hasArrayPath(row.varName)" class="path-array-badge" title="Campo proveniente de array">[]</span>
                </div>
                <span *ngIf="hasNestedPath(row.varName)" class="path-context">{{ getPathContext(row.varName) | underscoreWrap }}</span>
              </div>
            </ng-container>

            <ng-template #plainValue>
              <ng-container *ngIf="isMantenedorEmptyCell(flowTable, row, column.field, row[column.field]); else plainTextValue">
                <span class="empty-domain-badge" [ngClass]="getMantenedorEmptyBadgeClass(row, column.field)" [attr.title]="getMantenedorEmptyLabel(row, column.field)">
                  <span *ngIf="getMantenedorEmptyIcon(row, column.field)" class="material-symbols-outlined empty-domain-icon">{{ getMantenedorEmptyIcon(row, column.field) }}</span>
                  <span>{{ getMantenedorEmptyLabel(row, column.field) | underscoreWrap }}</span>
                </span>
              </ng-container>
              <ng-template #plainTextValue>
                <span class="cell-wrap-value">{{ getCellDisplayValue(row, column.field) | underscoreWrap }}</span>
              </ng-template>
            </ng-template>
          </ng-template>
        </ng-template>

      </efx-grid-column>

      <efx-grid-column field="" header="Es Hash" [isVisible]="true" [isSortable]="false" width="10"
        *ngSwitchCase="OptionFlowTable.Mantenedor">
        <ng-template let-row="row">
          <span class="material-symbols-outlined font-bold"
            [ngStyle]="{'color': row.isHash  ? 'var(--efx-primary-green)' : 'var(--efx-primary-red)'  }">
            {{ row.isHash ? 'done' : 'close' }}
          </span>
        </ng-template>
      </efx-grid-column>

      <efx-grid-column field="" header="Acciones" [isVisible]="true" [isSortable]="false"
        *ngSwitchCase="OptionFlowTable.Mantenedor" width="10">
        <ng-template let-row="row">
          <div class="acciones">
            <button class="efx-button-tertiary butonActions" title="Editar SubDominio" (click)="onEditButton.emit(row)">
              <span class="material-symbols-outlined cursor-pointer" style="color: #007298;">edit</span>
            </button>

            <button class="efx-button-tertiary butonActions" title="Eliminar SubDominio"
              (click)="onDeletedButton.emit(row)">
              <span class="material-symbols-outlined cursor-pointer" style="color: #E8002A;">delete</span>
            </button>
          </div>
        </ng-template>
      </efx-grid-column>

      <efx-grid-column *ngSwitchCase="OptionFlowTable.Configuracion" field="" header="Visible" width="10"
        [isVisible]="true" [isSortable]="false">
        <ng-template let-row="row">
          <efx-slide-toggle [id]="row.varName" [checked]="row.visible"
            (change)="onToggleChange(row, $event)">
          </efx-slide-toggle>
        </ng-template>
      </efx-grid-column>

    </efx-data-table>

    <efx-pager *ngIf="flowTable !== OptionFlowTable.VistaPrevia" [dataSource]="dataSource" [pageSize]="pageSizeTable"
      [maxPagingButtons]="6" [showPagerSummary]="false"></efx-pager>
  </ng-container>

  <ng-template #searchTable>
    <table class="efx-table" mat-table [dataSource]="dataSourceMaterial" aria-label="Search" matSort>
      <ng-container *ngFor="let columna of columnsTable" [matColumnDef]="columna.field">
        <th class="m-0" mat-header-cell *matHeaderCellDef>{{ columna.header | titlecase }}</th>
        <td mat-cell *matCellDef="let row">{{ row[columna.field] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsTableMaterial"></tr>
      <tr class="cursor-pointer" mat-row *matRowDef="let row; columns: columnsTableMaterial" (click)="onClickRow.emit(row)"></tr>
    </table>
  </ng-template>

</div>